import type { RevisionVariables, RevisionVariableValue } from '../types';

export type VariableDiffEntry =
    | { type: 'added'; value: RevisionVariableValue }
    | { type: 'deleted'; value: RevisionVariableValue }
    | { type: 'modified'; before: RevisionVariableValue; after: RevisionVariableValue };

export type VariablesDiffResult = {
    diffs: Map<string, VariableDiffEntry>;
};

/**
 * Compute the diff between two sets of variables (added / deleted / modified per key).
 * Variables are flat key/value records of primitive values, so we don't need util-tree-merge here.
 */
export function diffRevisionVariables(
    current: RevisionVariables | undefined,
    base: RevisionVariables | undefined
): VariablesDiffResult {
    const diffs = new Map<string, VariableDiffEntry>();
    const keys = new Set<string>([...Object.keys(current ?? {}), ...Object.keys(base ?? {})]);
    for (const key of keys) {
        const c = current?.[key];
        const b = base?.[key];
        if (c === undefined && b !== undefined) {
            diffs.set(key, { type: 'deleted', value: b });
        } else if (b === undefined && c !== undefined) {
            diffs.set(key, { type: 'added', value: c });
        } else if (c !== undefined && b !== undefined && c !== b) {
            diffs.set(key, { type: 'modified', before: b, after: c });
        }
    }
    return { diffs };
}
